import React from 'react';
import LegalDocument from './LegalDocument';
import privacyContent from './content/privacy-policy.md?raw';

interface PrivacyPolicyProps {
  embedded?: boolean;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ embedded = false }) => {
  return <LegalDocument content={privacyContent} embedded={embedded} />;
};

export default PrivacyPolicy;
